import {createSelector} from 'reselect'
import type {RootState} from 'services/store'

export const rootCreditsSelector = (state: RootState) => state.credits
export const creditsStatusSelector = createSelector(
  [rootCreditsSelector],
  credits => credits.status
)
export const creditsSelector = createSelector([rootCreditsSelector], credits => credits.data)
export const creditsErrorSelector = createSelector([rootCreditsSelector], credits => credits.error)
